export const gradovi = [
  "Ada",
  "Apatin",
  "Aleksandrovac",
  "Aleksinac",
  "Alibunar",
  "Aranđelovac",
  "Arilje",
  "Bač",
  "Babušnica",
  "Bajina Bašta",
  "Barajevo",
  "Batočina",
  "Bačka Palanka",
  "Bačka Topola",
  "Bački Petrovac",
  "Bela Crkva",
  "Bela Palanka",
  "Beočin",
  "Bečej",
  "Blace",
  "Bogatić",
  "Bojnik",
  "Boljevac",
  "Bor",
  "Bosilegrad",
  "Brus",
  "Bujanovac",
  "Crna Trava",
  "Crveni Krst",
  "Čajetina",
  "Čačak",
  "Čoka",
  "Ćićevac",
  "Ćuprija",
  "Čukarica",
  "Despotovac",
  "Dimitrovgrad",
  "Doljevac",
  "Gadžin Han",
  "Golubac",
  "Gornji Milanovac",
  "Grocka",
  "Inđija",
  "Irig",
  "Ivanjica",
  "Jagodina",
  "Kanjiža",
  "Kikinda",
  "Kladovo",
  "Knić",
  "Knjaževac",
  "Koceljeva",
  "Kosjerić",
  "Kovin",
  "Kragujevac",
  "Kraljevo",
  "Krupanj",
  "Kruševac",
  "Kovačica",
  "Kučevo",
  "Kula",
  "Kuršumlija",
  "Lajkovac",
  "Lapovo",
  "Lazarevac",
  "Lebane",
  "Leskovac",
  "Ljubovija",
  "Ljig",
  "Loznica",
  "Lučani",
  "Majdanpek",
  "Mali Iđoš",
  "Mali Zvornik",
  "Malo Crniće",
  "Medveđa",
  "Mediana",
  "Merošina",
  "Mionica",
  "Mladenovac",
  "Negotin",
  "Niš",
  "Niška Banja",
  "Nova Crnja",
  "Nova Varoš",
  "Novi Bečej",
  "Novi Kneževac",
  "Novi Beograd",
  "Novi Pazar",
  "Novi Sad",
  "Obrenovac",
  "Odžaci",
  "Opovo",
  "Osečina",
  "Palilula",
  "Palilula (Niš)",
  "Pantelej",
  "Pančevo",
  "Paraćin",
  "Pećinci",
  "Petrovac na Mlavi",
  "Pirot",
  "Plandište",
  "Požarevac",
  "Požega",
  "Preševo",
  "Priboj",
  "Prijepolje",
  "Prokuplje",
  "Rača",
  "Ražanj",
  "Rakovica",
  "Raška",
  "Rekovac",
  "Ruma",
  "Savski venac",
  "Sečanj",
  "Senta",
  "Sjenica",
  "Smederevo",
  "Smederevska Palanka",
  "Sokobanja",
  "Sombor",
  "Sopot",
  "Srbobran",
  "Sremska Mitrovica",
  "Sremski Karlovci",
  "Stara Pazova",
  "Stari grad",
  "Subotica",
  "Surčin",
  "Surdulica",
  "Svilajnac",
  "Svrljig",
  "Šabac",
  "Šid",
  "Temerin",
  "Titel",
  "Topola",
  "Trgovište",
  "Trstenik",
  "Tutin",
  "Ub",
  "Užice",
  "Valjevo",
  "Varvarin",
  "Velika Plana",
  "Veliko Gradište",
  "Vladičin Han",
  "Vladimirci",
  "Vlasotince",
  "Voždovac",
  "Vračar",
  "Vranje",
  "Vrbas",
  "Vrnjačka Banja",
  "Vršac",
  "Zaječar",
  "Zemun",
  "Zrenjanin",
  "Žabalj",
  "Žabari",
  "Žagubica",
  "Žitište",
  "Žitorađa",
  "Zvezdara"
];